import axios from "@/axios";

const getDefaultState = () => ({
    unidades: []
});
  
const state = getDefaultState();

const mutations = {
	SET_UNIDADES(state, unidades) {
		state.unidades = unidades;
	},
    reset(state) {
        Object.assign(state, getDefaultState());
    }
};

const actions = {
	async fetchUnidades({ commit }) {
		try {
			const response = await axios.get("/unidades");
			commit("SET_UNIDADES", response.data.unidades);
		} catch (error) {
			console.error("Erro ao buscar unidades:", error);
			throw error;
		}
	},

	async fetchLogsDataRelatorio(_, {unidadeId, dataInicio, dataFim, page, per_page}) {
        try {
            const response = await axios.get(`/unidades/${unidadeId}/logs/${dataInicio}/${dataFim}?page=${page}&per_page=${per_page}`);
            return response.data;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    },

	async fetchUnidadesConsultaAvancada(_, {ids, regras, data}) {
		try {
			const response = await axios.post("/unidades/consulta-avancada", {
				ids,
				regras,
				data
			});
			return response.data;
		} catch (error) {
			console.error("Erro ao buscar unidades consulta avançada:", error);
			throw error;
		}
	}
};

const getters = {
	getUnidades: (state) =>  state.unidades
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
